import { Store } from 'redux';
import { i18n } from 'i18next';
import { createInstance } from 'util/i18n';
import { setLanguageRequest, setLanguageSuccess } from 'actions/shellActions';
import { languageLoadFailure } from 'actions/appActions';

export const loadLanguageFile = (store: Store<{}>): i18n => {
    const i18n = createInstance(errors => {
        if (errors) {
            const msg = errors.join('; ');
            console.error('Failed to load the language: ', msg);
        }
    });
    i18n.on('languageChanged', (languageCode: string) => {
        // Strip locale specifier unless this is Chinese
        const [ , twoLetterCode = languageCode ] = /^(..)(?:-.+)$/.exec(languageCode) || [];
        if (twoLetterCode.toLowerCase() !== 'zh') {
            languageCode = twoLetterCode;
        }
        store.dispatch(setLanguageSuccess(languageCode));
    });
    i18n.on('failedLoading', (languageCode: string, ns: string, msg: string) => {
        // Ignore failures for locale-specific variants (TODO: make an exception for Chinese...)
        if (languageCode.indexOf('-') > 0) {
            languageCode = languageCode.substr(0, 2);
            store.dispatch(setLanguageRequest(languageCode));
            return;
        }
        store.dispatch(languageLoadFailure(new Error(msg), { languageCode }));
    });
    return i18n;
};



// WEBPACK FOOTER //
// ./src/startup/loadLanguageFile.ts